import dayjs from 'dayjs'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat, differenceDate } from 'shared/lib/dateFormat'

/**
 * Форматирует даты для отображения в header
 * @param startDate - Дата начала
 * @param endDate - Дата окончания
 * @returns Отформатированная строка вида "15 янв – 20 янв" или undefined
 */
export const formatDatesHeader = (
  startDate?: string,
  endDate?: string,
): string | undefined => {
  if (!startDate || !endDate) return undefined

  const startFormatted = dateFormat(
    startDate,
    DATE_FORMAT_LIST.DATE_MONTH_SHORT,
  )
  const endFormatted = dateFormat(endDate, DATE_FORMAT_LIST.DATE_MONTH_SHORT)

  return `${startFormatted} – ${endFormatted}`
}

/**
 * Вычисляет количество ночей между датами
 * @param startDate - Дата начала
 * @param endDate - Дата окончания
 * @returns Количество ночей или undefined
 */
export const calculateNights = (
  startDate?: string,
  endDate?: string,
): number | undefined => {
  if (!startDate || !endDate) return undefined

  const startDateOnly = dayjs(startDate).startOf('day')
  const endDateOnly = dayjs(endDate).startOf('day')

  return differenceDate({
    dateStart: startDateOnly.toDate(),
    dateEnd: endDateOnly.toDate(),
    type: 'day',
  })
}
